import { useDashboard } from '@/hooks/queries/useDashboard';
import { ArrowUp } from 'lucide-react';

interface DailySalesCardProps {
  onClick?: () => void;
  className?: string;
}

function formatFCFA(value: number): string {
  return `${new Intl.NumberFormat('fr-FR').format(Math.round(value))} FCFA`;
}

export function DailySalesCard({ onClick, className }: DailySalesCardProps) {
  const { data: dashboardData } = useDashboard('1d');

  const revenue = dashboardData?.summary?.revenue;
  const displayRevenue =
    typeof revenue === 'number' && revenue > 0 ? formatFCFA(revenue) : '450 000 FCFA';

  const deltaPercent = dashboardData?.deltas?.revenue_vs_previous_percent;
  const displayDelta =
    typeof deltaPercent === 'number' && deltaPercent !== 0
      ? `${deltaPercent > 0 ? '+' : ''}${Math.round(deltaPercent)}%`
      : '+12%';

  return (
    <div
      onClick={onClick}
      className={`w-full rounded-[24px] bg-white dark:bg-charcoal-800 p-5 shadow-[0_2px_15px_rgba(0,0,0,0.03)] border-0 flex items-center justify-between text-left transition-all ${
        onClick ? 'cursor-pointer hover:shadow-md active:scale-[0.99]' : ''
      } ${className ?? ''}`}
    >
      <div className="flex flex-col">
        <span className="text-[11px] font-mono font-semibold uppercase tracking-wider text-slate-400 dark:text-slate-400">
          Ventes du jour
        </span>
        <span className="mt-1 text-2xl font-bold font-mono text-slate-900 dark:text-white tracking-tight">
          {displayRevenue}
        </span>
      </div>

      <div className="inline-flex items-center gap-1 px-3 py-1.5 rounded-full bg-[#e2f4d8] dark:bg-emerald-950/60 text-[#2d6914] dark:text-emerald-300 text-xs font-semibold shrink-0">
        <ArrowUp className="size-3.5 stroke-[2.5]" />
        <span>{displayDelta} vs hier</span>
      </div>
    </div>
  );
}
